export default "__VITE_ASSET__4YUY9nxvQVjPEr5wcQK7mg__"